// src/data/sidebar_config.js

const STANDARD_MENU = [
  {
    key: "social_impact_intelligence",
    label: "Social Impact Intelligence",
    icon: "bi bi-graph-up-arrow"
  },
  {
    key: "skills_development_youth_employment",
    label: "Skills Development & Youth Employment",
    icon: "bi bi-mortarboard",
    type: "section",
    children: [
      { key: "sdye_programmes_delivery", label: "Programmes & Delivery", icon: "bi bi-clipboard-check" },
      { key: "sdye_social_impact", label: "Social Impact", icon: "bi bi-globe" },
      { key: "sdye_compliance", label: "Compliance", icon: "bi bi-file-earmark-check" }
    ]
  },
  {
    key: "socio_economic_development",
    label: "Socio-Economic Development",
    icon: "bi bi-diagram-3",
    type: "section",
    children: [
      { key: "sed_programmes_delivery", label: "Programmes & Delivery", icon: "bi bi-clipboard-check" },
      { key: "sed_social_impact", label: "Social Impact", icon: "bi bi-globe" },
      { key: "sed_compliance", label: "Compliance", icon: "bi bi-file-earmark-check" }
    ]
  }
];

export const SIDEBAR_CONFIG = {
  fund_manager: {
    header_title: "Fund Manager",
    menu: STANDARD_MENU,
    include_programmes_component: false
  },

  donor_portal: {
    header_title: "Donor",
    menu: STANDARD_MENU,
    include_programmes_component: false
  },

  governance: {
    header_title: "Governance",
    menu: STANDARD_MENU,
    include_programmes_component: false
  },

  entrepreneur: {
    header_title: "Entrepreneur",
    menu: STANDARD_MENU,
    include_programmes_component: false
  }
};

export const ROLE_TO_APP_KEY = {
  fund_manager: "fund_manager",
  donor: "donor_portal",
  donor_portal: "donor_portal",
  governance: "governance",
  entrepreneur: "entrepreneur"
};
